/**
 * Constants
 * */
export const moduleName = `isAdmin`;

/**
 * Reducer
 * */

export default function reducer(state = false, action) {
  const {type} = action;

  switch (type) {
    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const isAdminSelector = (state) => state[moduleName];

/**
 * Action Creators
 * */
